import React, { useState, useImperativeHandle, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Dialog, DialogContent, Grid } from '@mui/material';
import { Button, Form, Box, Alert, Stack } from "@curves/ui-base";
import GradientColorHeader from '@icoach/components/dialog/GradientColorHeader';
import useClubPermissionApi from '@apis/useClubPermissionApi';

// suspendType 目前只有店休 先寫死 by Allen

const RolePermissionChangeConfirmationDialog = React.forwardRef((props, ref) => {
    const { sourceData, editLabelText, permissionID, clubID, setChecked: setCheckedProps } = props;
    const [isOpen, setOpen] = useState(false);
    const [isChecked, setChecked] = useState(null);
    const { enqueueSnackbar: _snackbar } = useSnackbar();
    const { putClubPermissionsApi } = useClubPermissionApi();

    const getParams = useCallback(
        () => {
            return {
                isEnabled: isChecked,
                employeeRankType: sourceData.employeeRankType,
                permissionID: permissionID,
                clubID,
            };
        },
        // eslint-disable-next-line
        [isChecked]
    );

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmitOnClick = useCallback(
        () => {
            const params = getParams();
            postEmployeeRankPermissionApi(params, isChecked);
        },
        // eslint-disable-next-line
        [isChecked]
    );

    const postEmployeeRankPermissionApi = async (params, isChecked) => {
        const resp = await putClubPermissionsApi(params);
        if (resp) {
            setCheckedProps(isChecked);
            _snackbar('修改成功', { variant: 'success' });
            setOpen(false);
        }
    };

    useImperativeHandle(
        ref,
        () => {
            return {
                openDialog: (checked) => {
                    setChecked(checked);
                    setOpen(true);
                },
            };
        },
        // eslint-disable-next-line
        []
    );

    return (
        <Dialog open={isOpen} PaperProps={{ className: 'wx-40rem', component: Form }} onSubmit={handleSubmitOnClick} fullWidth>
            <GradientColorHeader>確認變更使用權限？</GradientColorHeader>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid xs={12} item>
                        <React.Fragment>
                            <Box className="p-2">
                                確定是否要
                                <Box component="span" className="px-1">
                                    {isChecked ? '新增' : '移除'}
                                </Box>
                                <Box component="span" className="font-weight-bold pr-1">
                                    {sourceData.employeeRankTypeText}
                                </Box>
                                的
                                <Box component="span" className="font-weight-bold mx-1">
                                    {editLabelText}
                                </Box>
                                權限嗎？
                            </Box>
                            <Alert severity="warning" variant="filled" color="gray" messageStyle={{ fontSize: `1.5rem` }}>
                                提醒您：變更權限後，該職稱人員需重新登入，變更才會生效。
                            </Alert>
                        </React.Fragment>
                    </Grid>
                </Grid>
            </DialogContent>
            <Stack justifyContent="center" className="pb-2" spacing={2}>
                <Button variant="outlined" onClick={handleClose}>
                    取消
                </Button>
                <Button variant="contained" type="submit">
                    送出
                </Button>
            </Stack>
        </Dialog>
    );
});

export default RolePermissionChangeConfirmationDialog;
